<ng-template #customFieldTemplate>
    <div class="modal-body">
        <form *ngIf="currentViewType === VIEW_MODE.FORM" class="builder" [formGroup]="fieldForm" autocomplete="off">
            <div class="form-group row">
                <label class="col-sm-3 col-form-label required"
                    >Name <i class="fa fa-question-circle" ngbTooltip="Field label that will be displayed to admin"></i>
                </label>
                <div class="col-sm-7">
                    <input
                        [ngClass]="{ error: fieldForm.controls.name.invalid && showError }"
                        name="name"
                        formControlName="name"
                        class="form-control"
                    />
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label required"
                    >Display Name
                    <i
                        class="fa fa-question-circle"
                        ngbTooltip="Field label that will be displayed to professional"
                    ></i>
                </label>
                <div class="col-sm-7">
                    <input
                        [ngClass]="{ error: fieldForm.controls.label.invalid && showError }"
                        name="display"
                        formControlName="label"
                        required
                        minlength="1"
                        class="form-control"
                    />
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Group</label>
                <div class="col-sm-7">
                    <select name="group_id" formControlName="group_id" class="form-control">
                        <option [ngValue]="null">None</option>
                        <option *ngFor="let group of custGroups" [ngValue]="group.group_id">{{ group.name }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Field Type</label>
                <div class="col-sm-7">
                    <select name="type_id" formControlName="type_id" class="form-control">
                        <option *ngFor="let customType of CUSTOM_FIELDS_TYPES_LIST" [ngValue]="customType.id">{{
                            customType.name
                        }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Required</label>
                <div class="col-sm-7 col-form-label">
                    <cm-checkbox name="is_required" formControlName="is_required">Yes</cm-checkbox>
                </div>
            </div>
            <div class="form-group row" *ngIf="fieldForm.controls.type_id?.value !== CUSTOM_FIELD_TYPES.ATTACHMENT">
                <label class="col-sm-3 col-form-label">
                    Encrypt <span class="fa fa-question-circle" [ngbTooltip]="encryptTooltip" placement="right"></span>
                </label>
                <div class="col-sm-7 col-form-label">
                    <cm-checkbox name="is_required" formControlName="is_encrypted">Yes</cm-checkbox>
                </div>
                <div class="col-sm-10" *ngIf="!isEncryptingAllowed">
                    <cm-message-block type="info" [showIcon]="false">
                        NOTE: Please note that the system is currently processing updates for this field. The field will
                        be available to edit in approximately 20 minutes.
                    </cm-message-block>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Available in Users list</label>
                <div class="col-sm-7 col-form-label"><cm-checkbox formControlName="use_in_list">Yes</cm-checkbox></div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Default Value</label>
                <div class="col-sm-7">
                    <cm-custom-field-value
                        *ngIf="fieldForm.controls.type_id?.value !== CUSTOM_FIELD_TYPES.ATTACHMENT"
                        [defaultReadonly]="false"
                        [fieldType]="fieldForm.controls.type_id?.value"
                        [value]="fieldForm.value.default_value"
                        (valueChange)="updateDefaultValue($event)"
                    >
                    </cm-custom-field-value>
                    <p
                        *ngIf="fieldForm.controls.type_id?.value === CUSTOM_FIELD_TYPES.ATTACHMENT"
                        class="controls--disabled"
                    >
                        Not available
                    </p>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label"
                    >Status
                    <i class="fa fa-question-circle" ngbTooltip="Enables or disables field on all users profiles"></i>
                </label>
                <div class="col-sm-7">
                    <select name="status_id" formControlName="status_id" class="form-control">
                        <option *ngFor="let customStatus of CUSTOM_FIELDS_STATUS_LIST" [ngValue]="customStatus.id">
                            {{ customStatus.name }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-3 col-form-label">Available in profile</label>
                <div class="col-sm-7 col-form-label">
                    <cm-checkbox formControlName="use_in_profile">Yes</cm-checkbox>
                </div>
            </div>

            <div class="form-group row" *ngIf="fieldForm.controls.use_in_profile.value">
                <label class="col-sm-3 col-form-label">Read-only</label>
                <div class="col-sm-7 col-form-label">
                    <cm-checkbox name="professional_read_only" formControlName="professional_read_only"
                        >Yes</cm-checkbox
                    >
                </div>
            </div>

            <div *ngIf="fieldForm.value.field_id" class="form-group row">
                <label class="col-sm-3 col-form-label">Mapped</label>
                <div class="col-sm-7 col-form-label">{{ isMapped ? 'Yes' : 'No' }}</div>
            </div>

            <cm-inline-error
                *ngIf="validationErrors && validationErrors.length"
                [errorMessages]="validationErrors"
                class="align-center"
            ></cm-inline-error>
        </form>
        <p *ngIf="currentViewType === VIEW_MODE.ENCRYPTED_INFO">
            Please check to see if the field you are adding should be encrypted. If you would like to encrypt the
            information contained in this field, please select “Encrypt & Save”. If you do not wish to encrypt, please
            select “Save as Is”.
        </p>
    </div>
    <div class="modal-footer">
        <ng-container *ngIf="currentViewType === VIEW_MODE.FORM">
            <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="save()">SAVE</button>
        </ng-container>
        <ng-container *ngIf="currentViewType === VIEW_MODE.ENCRYPTED_INFO">
            <button type="button" class="btn btn-default" (click)="submit()">Save as Is</button>
            <button type="button" class="btn btn-primary" (click)="encryptAndSubmit()">Encrypt & Save</button>
        </ng-container>
    </div>
</ng-template>
